<template>
  <div class="logpagelist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" label-width="70px">
        <el-form-item :label="$t('manage.name58')" prop="searchTime">
          <el-date-picker
            v-model="queryInfo.searchTime"
            type="datetimerange"
           value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
            align="left"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="medium" @click="getPageList" >{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="restQueryInfo">{{ $t('public.name4') }}</el-button>
      </div>
    </div>

    <div class="add-user">
      <el-button type="primary" size="medium" @click="exportData" :loading="loading" >{{ $t('manage.name60') }}</el-button>
    </div>
    <el-table :data="logpagelist" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('manage.name59')" prop="operateTime" sortable> </el-table-column>
      <el-table-column :label="$t('manage.name61')" prop="operatorId" sortable></el-table-column>
      <el-table-column :label="$t('manage.name62')" prop="operatorName" sortable></el-table-column>
      <!-- <el-table-column :label="$t('manage.name63')" prop="operateType" sortable></el-table-column> -->
      <el-table-column :label="$t('manage.name64')" prop="operateContent" sortable></el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { logList, exportLog } from '@/api/manage.js'
import { downloadExcel } from '@/utils/utils'
export default {
  data() {
    return {
      queryInfo: {
        startTime: '',
        endTime: '',
        page: 1,
        limit: 10,
        searchTime: null
      },
      logpagelist: [
        {
          userId: '',
          fullName: '',
          url: '',
          requestDesc: '',
          status: '',
          requestTime: '',
          requestZhDesc: ''
        }
      ],
      total: 0,
      loading: false,
      tableLoading: false,
      buttonPerms: ''
    }
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.getLogList()
  },
  methods: {
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.getLogList()
    },
    async getLogList() {
      this.tableLoading = true
      let data = {}
      if (this.queryInfo.searchTime) {
        if (this.queryInfo.searchTime.length > 0) {
          data = {
            page: this.queryInfo.page,
            limit: this.queryInfo.limit,
            startTime: this.queryInfo.searchTime[0],
            endTime: this.queryInfo.searchTime[1]
          }
        }
      } else {
        data = {
          page: this.queryInfo.page,
          limit: this.queryInfo.limit
        }
      }

      const res = await logList(data)
      if (res.code === 200) {
        this.total = res.data.total
        this.logpagelist = res.data.list
        this.tableLoading = false
      } else {
        this.logpagelist = []
        this.total = 0
        this.tableLoading = false
      }
    },
    exportData() {
      let data = {}
      this.loading = true
      if (this.queryInfo.searchTime) {
        if (this.queryInfo.searchTime.length > 0) {
          data = {
            startTime: this.queryInfo.searchTime[0],
            endTime: this.queryInfo.searchTime[1]
          }
        }
      }
      exportLog(data)
        .then(res => {
          downloadExcel(res, this.$t('screen.name45'))
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    restQueryInfo() {
      this.queryInfo = {
        startTime: '',
        endTime: '',
        page: 1,
        limit: 10,
        searchTime: null
      }
      this.getLogList()
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.getLogList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getLogList()
    }
  }
}
</script>
<style lang="scss" scoped>
.logpagelist-container {
  display: flex;
  flex-direction: column;
  .search-layout {
    display: flex;
    justify-content: space-between;
  }
}
</style>
